import React from 'react'
import { Link } from 'react-router-dom'
import { Home } from 'lucide-react'

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950">
      <div className="text-center">
        <div className="text-6xl font-bold text-primary-600 dark:text-primary-400 mb-4">404</div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Page non trouvée</h1>
        <p className="text-gray-600 dark:text-gray-400 mb-8">
          La page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        <Link
          to="/"
          className="btn-primary inline-flex items-center space-x-2"
        >
          <Home className="w-5 h-5" />
          <span>Retour au tableau de bord</span>
        </Link>
      </div>
    </div>
  )
}

export default NotFound
